module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPHBhdGggZmlsbD0iIzAwNjViZCIgZD0iTTAgMGg2NDB2NDgwSDB6Ii8+CiAgPHBhdGggZD0iTTAgMGw1IDNNMCAzbDUtMyIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9Ii42IiB0cmFuc2Zvcm09InNjYWxlKDEyOCAxNjApIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/gb-sct.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/gb-sct.svg
// module chunks = 0